import React from 'react';
import Konva from 'konva';
import { Text } from 'react-konva';
import {
  nodeWidth,
  // targetFocusMobileScale,
  isDevelopment,
  fontFamily,
  fullNameFontColor,
  minimal,
  fullNameFontSize,
  fullNameLargeFontSize,
  cachetree,
} from '../../library/constants';
import {
  isMobileTablet,
  isMobilePhone,
  urlGet,
} from '../../library/calc';


class GhostLabel extends React.Component {

  componentDidUpdate(){
    if(cachetree){
      this.refs.ghostLabelNodeCache.cache();
    }
  }

  hovering(hovering){
    this.props.callRefObj({key: `node_n-${this.props.n}`, method: 'callHover', param: hovering});
  }

  render() {

    let {
      a, // adder
      n,
      idp,
      left,
      top,
      onClickedNode,
      stopStageClickPropagation,
      cursorBecomesMove,
      cursorBecomesPointer,
      setNodeForFlipFocus,
      setShowMobileFlipCard,
      userTouchedNode,
      addNodeObj,
      // showProgressIndicator,
      showTreeOverlay,
      setFlipCardScreenIsOn,
      fontSizeChoice,
    } = this.props;

    const fontSize = ( fontSizeChoice === 'default' ? fullNameFontSize: fullNameLargeFontSize)

    let text = `${addNodeObj[( !minimal  && typeof(a) !== 'undefined' ? 'frontendGhostLabel': 'nonAddableGhost')]}`;

    if(urlGet('nodeIs') === "n") text = `${text} (${n})`;
    if(urlGet('nodeIs') === "idp") text = `${idp}`;
    if(urlGet('nodeIs') === "prId") text = `${this.props.pr_id}`;

    const _text = new Konva.Text({
          x: 0,
          y: 0,
          text,
          fontSize,
          fontFamily,
          align: 'center'
        });

    const textWidth = _text.getWidth();

    const _left = (( nodeWidth ) / 2 ) - ( textWidth / 2);

    left += _left;
    top += ( this.props.isPedigree ?  5: 12);

    return <Text
      ref={'ghostLabelNodeCache'}
      x={left}
      y={top}
      // text={`${text} - ${n}`}
      text={`${text}`}
      width={textWidth}
      fontSize={fontSize}
      fontFamily={fontFamily}
      fill={fullNameFontColor}

      onTouchStart={()=>{
        if(typeof(a) === 'undefined') return;
        stopStageClickPropagation({fromWhere:'ghost label'});
        userTouchedNode({
          node: n,
          callback: ()=>{
            if(isMobileTablet()){
              showTreeOverlay();
              onClickedNode(n);
            }
            if(isMobilePhone()) {

              const screenIsOn = `addFormFromGhost`;
              setFlipCardScreenIsOn({screenIsOn});
              setNodeForFlipFocus(n);
              setShowMobileFlipCard(n);

              const { choice, marriageId } = addNodeObj;
              let { pr_id } = addNodeObj;
              if(typeof(pr_id) === 'undefined') pr_id = null;
              if(!isDevelopment){
                setTimeout(() => {
                  window.openAddNode(pr_id, choice, marriageId);
                }, 700);
                // console.log(`window.openAddNode(${ pr_id }, '${ choice }', ${ marriageId })`);
              }
              else{
                // console.log(`window.openAddNode(${ pr_id }, '${ choice }', ${ marriageId })`);
              }

            };
          },
          fromWhere: 'ghost label'});
      }}

      onClick={()=>{
        if(isMobilePhone() ) return;
        if(typeof(a) === 'undefined') return;
        showTreeOverlay();
        onClickedNode(n);
      }}

      onMouseenter={()=>{
        this.hovering(true);
        cursorBecomesPointer();
      }}
      onMouseleave={()=>{
        this.hovering(false);
        cursorBecomesMove();
      }}

    />;
  }
}

export default GhostLabel;
